import React,{useState,useEffect, useRef} from 'react'
import { Form,Modal, Input,App, Radio, Rate,} from 'antd'
import { useTaskManageUpdateQuery, useTaskManageUpdateSaveMutation } from '../../store/BnsKeJiApi';
import { EditOutlined } from '@ant-design/icons';
import { InterfaceGrade } from './InterfaceGrade';
import MyEditor from '../../cpn/MyEditor';
function InterfaceEdit(props) {
    
    
    const {message} = App.useApp();
    const [form] = Form.useForm();
    const onCreate = (values) => {
        setOpen(false);
    };
    const [open,setOpen] = useState()
    const [info,setInfo] = useState({
        et_content: '',
        et_e_id: localStorage.getItem('e_id'),
        et_name: '',
        et_update_uid: localStorage.getItem('eu_id'),
        et_update_uname: localStorage.getItem('eu_name'),
        etu_user_id: '',
        etu_user_name: '',
        et_date:'',
        et_id:props.et_id,
        et_grade:'1',
        et_status:'1',
    });
    const {data,isSuccess} = useTaskManageUpdateQuery({et_id:props.et_id},{skip:!open})
    const editForm = useRef();
    useEffect(() => {
        if(isSuccess){
            if(data.Status==='success'){
                // console.log(data);
                let etu_user_id;
                etu_user_id = data.Result.user.map((item) => {
                    return item.etu_user_id
                })
                let etu_user_name;
                etu_user_name = data.Result.user.map((item) => {
                    return item.etu_user_name
                })
                // console.log(etu_user_id);
                editForm.current.setFieldsValue({
                    et_status:data.Result.et_status,
                    et_content:data.Result.et_content,
                    et_grade:data.Result.et_grade,
                    et_name:data.Result.et_name,
                    et_bg_name:data.Result.et_bg_name,
                    etu_user_id:etu_user_id,                          
                    et_bgn_name:data.Result.et_bgn_name,              
                    et_bbb_name:data.Result.et_bbb_name,              
                });
                setInfo(prevState=>({...prevState,
                    et_date:data.Result.et_date,
                    et_status:data.Result.et_status,
                    et_content:data.Result.et_content,
                    et_name:data.Result.et_name, 
                    etu_user_id:etu_user_id,    
                    etu_user_name:etu_user_name,  
                    et_grade:data.Result.et_grade,                            
                    et_bg_id:data.Result.et_bg_id,            
                    et_bg_name:data.Result.et_bg_name,         
                    et_bgn_id:data.Result.et_bgn_id,            
                    et_bgn_name:data.Result.et_bgn_name,            
                    et_bbb_id:data.Result.et_bbb_id,            
                    et_bbb_name:data.Result.et_bbb_name, 
                    et_id:data.Result.et_id,                                 
                }))
            }
        }
    },[data,isSuccess])
    const [summitUpdateSave] = useTaskManageUpdateSaveMutation()
    return (
        <>
            {localStorage.getItem('eu_id')===props.et_uid && <a onClick={() => {setOpen(true)}}><EditOutlined/> 修改接口</a>}
            <Modal
                open={open}
                title='修改接口'
                okText="提交"
                cancelText="取消"
                onCancel={() => {setOpen(false);}}
                width={1000}
                onOk={() => {
                    form
                        .validateFields()
                        .then((values) => {
                            form.resetFields();
                            onCreate(values);
                        })
                        .catch((info) => {
                            // console.log('Validate Failed:', info);
                        }); 
                        summitUpdateSave(info).then((res) => {
                            // console.log(res);
                            if (res.data.Status === 'success') {
                                message.success('修改成功！')                                
                                setOpen(false)                         
                            }
                            if (res.data.Status === 'fail') {
                                message.error('修改失败！'+res.data.Message)
                                
                            }
                        })                           
                }}
            >
                <Form
                    form={form}
                    layout="horizonal"
                    name={`form_module_edit_${props.et_id || ''}`} // 保证唯一
                    initialValues={{modifier: 'public',}}
                    labelCol={{ span: 3 }}
                    ref={editForm}
                >               
                    <Form.Item name="et_name" label='接口名称' wrapperCol={{span:15}} required >                        
                        <Input  onChange={(e) => {setInfo(prevState=>({...prevState,et_name:e.target.value,}))}}/>
                    </Form.Item>
                    <Form.Item name="et_status" label='接口状态' wrapperCol={{span:15}} required >                        
                        <Radio.Group
                             onChange={(e) => {setInfo(prevState=>({...prevState,et_status:e.target.value,}))}}
                        >
                            <Radio value='1'>待开发</Radio>
                            <Radio value='2'>待验收</Radio>
                            <Radio value='3'>已结束</Radio>
                        </Radio.Group>
                    </Form.Item>                         
                    <Form.Item name="et_grade" label='优先级' wrapperCol={{span:15}} required >                        
                        <Rate  
                            onChange={(e) => {
                                setInfo(prevState=>({...prevState,et_grade:e}))}
                            }
                            character={({ index = 0 }) => InterfaceGrade[index + 1]}
                        />
                    </Form.Item>
                    <Form.Item name="et_content" label='接口说明' wrapperCol={{span:21}} required >                        
                        <MyEditor onChange={(e) => {setInfo(prevState=>({...prevState,et_content:e}))}}/>
                    </Form.Item>                         
                        
                </Form>
            </Modal>
        </>
    )
}

export default InterfaceEdit